import { useState } from 'react';

import { IPersonaFront } from '@api/routers/user/service';

export const useBulkActions = () => {
  const [selectedItems, setSelectedItems] = useState<IPersonaFront[]>([]);

  const itemClick = (item: IPersonaFront) => {
    if (
      !selectedItems.find((s) => {
        return s.tokenId === item.tokenId;
      })
    ) {
      setSelectedItems((prev) => [...prev, item]);
    } else {
      setSelectedItems(selectedItems.filter((s) => s.tokenId !== item.tokenId));
    }
  };

  const clearAll = () => {
    setSelectedItems([]);
  };

  const selectItems = (items: IPersonaFront[]) => {
    setSelectedItems(items);
  };

  return { selectedItems, itemClick, clearAll, selectItems };
};
